module.exports = __webpack_public_path__ + "assets/img/gd4.aefc8056.jpg";